<template>
  <div class="page">
   <div class="bg-white " style="height: calc(100%);overflow-y: auto;">
    <el-card>
      <el-row>
        <el-col :span="12">
          <el-form size="small"  class="" ref="searchForm" :model="detForm">
            <el-row>
              <el-col :span="12">
                <el-form-item prop="" label="项目编号：">
                  <span>{{ detForm.proCode }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="" label="项目名称：">
                  <span>{{ detForm.name }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="" label="工程类别：">
                  <span>{{ detForm.kindName1 }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="" label="工程类型：">
                  <span>{{ detForm.kindName2 }}</span>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item prop="" label="项目单价：">
                  <span>$ {{ detForm.price }} / {{ detForm.unitEn }}</span>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item prop="" label="施工单位：">
                  <span>{{ setWorkUnitText(detForm.workUnitId) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="" label="施工指示：">
                  <div>{{ detForm.workPoint }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="" label="注意事项：">
                  <span>{{ detForm.workNote }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="" label="常规标准：">
                  <span>{{ detForm.workStandard }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="" label="备注信息：">
                  <span>{{ detForm.remarks }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="12">
          <ImageColumn :imageArray="detForm.picJsonList"></ImageColumn>
        </el-col>
      </el-row>
    </el-card>
      <div class="tableTitle">涉及项目：</div>
      <div style="min-height: calc(40% - 20px);">
      <vxe-table
          border="full"
          auto-resize
          resizable
          height="auto"
          :loading="loading"
          size="small"
          ref="cecUnmSetsTable"
          show-header-overflow
          show-overflow
          highlight-hover-row
          :menu-config="{}"
          :print-config="{}"
          :import-config="{
          importMethod: importMethod,
              types: ['csv', 'xls', 'xlsx'],
              remote: true,
          }"
          :export-config="{
              remote: true,
              filename: `套餐表数据${moment(new Date()).format(
              'YYYY-MM-DD'
              )}`,
              sheetName: '套餐表数据',
              exportMethod: exportMethod,
              types: ['xlsx'],
              modes: ['current', 'selected', 'all'],
          }"
          @sort-change="sortChangeHandle"
          :sort-config="{remote:true}"
          :data="detForm.others"
          :checkbox-config="{}">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column
            field="proCode"
            align="center"
            title="项目编号">
          </vxe-column>
          <vxe-column
            field="kindName1"
            align="center"
            title="工程类别">
          </vxe-column>
          <vxe-column
            field="kindName1"
            align="center"
            title="工程类型">
          </vxe-column>
  </vxe-table>
  </div>
  </div>
      <!-- 弹窗, 新增 / 修改 -->
  <!-- <CecUnmSetsForm  ref="cecUnmSetsForm" @refreshDataList="refreshList"></CecUnmSetsForm> -->
</div>
</template>

<script>
// import CecUnmSetsForm from './CecUnmSetsForm'
import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
import cecProjectService from '@/api/cecproject/cecProjectService'
import ImageColumn from '@/components/imageColumn'
export default {
  data () {
    return {
      detForm: {
        unitEn: '',
        price: '',
        description: '',
        unitCn: '',
        proCode: '',
        name: '',
        picJsonList: [],
        picJson: ''
      },
      tablePage: {
        orders: [{ column: 'sort', asc: false }]
      },
      loading: false,
      projectId: '',
      workUnitIdList: [],
      urlHearder: 'https://www.cecerp.com/userfiles/'
    }
  },
  components: {
    // CecUnmSetsForm
    ImageColumn
  },
  activated () {
    this.projectId = this.$route.query.id
    this.refreshList()
    this.workUnitIdList = this.$dictUtils.getDictList('cec_build_section')
  },
  methods: {

    // 返回施工小组
    setWorkUnitText (value) {
      if (!value) return
      let workUnit = value.split(',')
      let mapArray = workUnit.map(item => {
        let findDate = this.workUnitIdList.find(fitem => fitem.value === item)
        return findDate ? findDate.label : ''
      })
      return mapArray.join(',')
    },
    // 跳转套餐项目列表
    handSetsProject () {

    },
    // 获取数据列表
    refreshList () {
      this.loading = true
      cecProjectService.queryById(this.projectId).then(({data}) => {
        this.detForm = data
        if (data.picJson) {
          this.detForm.picJsonList = JSON.parse(data.picJson).map(citem => {
            citem.fileUrl = this.urlHearder + citem.fileStorePath + citem.filesIn
            return citem
          })
        }
        this.loading = false
      })
    },
    // 当前页
    currentChangeHandle ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.refreshList()
    },
    // 排序
    sortChangeHandle (obj) {
      this.tablePage.orders = []
      if (obj.order != null) {
        this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
      } else {
        this.tablePage.orders = [{ column: 'create_date', asc: false }]
      }
      this.refreshList()
    },
    // 新增
    add () {
      // this.$refs.cecUnmSetsForm.init('add', '')
    },
    // 修改
    edit (id) {
      id = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      })[0]
      // this.$refs.cecUnmSetsForm.init('edit', id)
    },
    // 查看
    view (id) {
      // this.$refs.cecUnmSetsForm.init('view', id)
    },
    // 删除
    del (id) {
      let ids = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      }).join(',')
      this.$confirm(`确定删除所选项吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        cecUnmSetsService.delete(ids).then(({data}) => {
          this.$message.success(data)
          this.refreshList()
          this.loading = false
        })
      })
    },
    // 下载模板
    downloadTpl () {
      this.loading = true
      cecUnmSetsService.exportTemplate().then(({data}) => {
  // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, '请假表单导入模板')
        this.loading = false
      }).catch(function (err) {
        this.loading = false
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    // 自定义服务端导入
    importMethod ({ file }) {
    // 处理表单
      const formBody = new FormData()
      formBody.append('file', file)
      this.loading = true
      cecUnmSetsService.importExcel(formBody).then(({data}) => {
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: data
        })
        this.refreshList()
      })
    },
    // 自定义服务端导出
    exportMethod ({ options }) {
    // 传给服务端的参数
      const params = {
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        orders: this.tablePage.orders,
        ...this.searchForm,
        filename: options.filename,
        sheetName: options.sheetName,
        isHeader: options.isHeader,
        original: options.original,
        mode: options.mode,
        selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
        exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
      }
      this.loading = true
      return cecUnmSetsService.exportExcel(params).then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, options.filename)
        this.loading = false
      }).catch(function (err) {
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.refreshList()
    }
  }
}
</script>
<style scoped>
.tableTitle{
  padding: 20px 0 10px 0;
  font-weight: bold;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-form-item__label{
  font-weight: bold;
  /* width: 100px; */
}
::v-deep .el-form-item{
  /* display: flex; */
}
</style>

